import Vuex, { MutationPayload } from 'vuex'
import { User } from '@/types/auth'
import Vue from 'vue'


export interface AppState {
    user: User|null;
    updateAvailable: boolean;
}


Vue.use(Vuex)
const store = new Vuex.Store({
    state: {
        user: null,
        updateAvailable: false
    } as AppState,
    actions: {},
    mutations: {
        initializeStore(state: AppState) {
            // Check the state exists in localStorage.
            const storedStoreStr = localStorage.getItem('store')
            if (typeof storedStoreStr === 'string') {
                const storedState = JSON.parse(storedStoreStr) as AppState
                // Replace the state object with the stored item only if the user is valid.
                if (storedState?.user && storedState.user in User) {
                    storedState.updateAvailable = false
                    this.replaceState(
                        Object.assign(state, storedState)
                    )
                }
            }
        },
        updateAvailable(currentState: AppState, available: boolean) {
            currentState.updateAvailable = available
        },
        updateUser(currentState: AppState, user: User) {
            currentState.user = user
        }
    },
    modules: {}
})

store.subscribe((mutation: MutationPayload, state: AppState) => {
    // Store the state object as a JSON string
    localStorage.setItem('store', JSON.stringify(state))
})


export default store
